import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Box, Grid, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import FormikActions from "../../../commons/formik/FormikActions";
import RequeridoLabel from "../../../commons/labels/RequeridoLabel";
import CircularLoading from "../../../commons/loading/CircularLoading";
import FechaPresentacionLabel from "../../../commons/planillas/FechaPresentacionLabel";
import PuestosFormContainer from "../../../commons/puestos/PuestosFormContainer";
import SectorFormContainer from "../../../commons/sectores/SectorFormContainer";
import { StyledNte } from "../../../styled/Prevencion";
import InformacionImportarArchivoContainer from "../commons/informacionImportarArchivo/InformacionImportarArchivoContainer";
import FeatureLabel from "../commons/labels/FeatureLabel";

const ConfeccionDelArchivoForm = ({
  initialValues,
  onSubmit,
  loading,
  idDependenciaEmpleador,
  isDownloadingNominas,
  handleDescargarNominas,
}) => {
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      enableReinitialize={true}
    >
      {({ values }) => (
        <Form >
          {loading
            ? <CircularLoading />
            : (
              <>
                <FechaPresentacionLabel />
                <Box ml={2} mb={5} mt={1} >
                  <Grid container spacing={3} >
                    <Grid item xs={10}>
                      <Typography color="error" variant="body2">
                        <strong>
                          Importante: En la Declaración Jurada NTE, los riesgos se vinculan obligatoriamente con tres datos: tarea codificada, puesto y sector (estos dos últimos en formato texto).
                          Esta información es requerida para la presentación Resolución 81.<br />
                          En este paso, podrá buscar puestos y/o sectores previamente declarados.<br />
                        </strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={2} />
                    <Grid item container xs={6}>
                      <Grid item xs={5}>
                        <Typography variant="h6">
                          Consulta Sectores Informados
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <SectorFormContainer
                          showDescription
                          idDependenciaEmpleador={idDependenciaEmpleador}
                          label={null}
                        />
                      </Grid>
                    </Grid>
                    <Grid item container xs={6}>
                      <Grid item xs={5} >
                        <Typography variant="h6">Consulta Puestos Informados</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <PuestosFormContainer
                          label={null}
                          idDependenciaEmpleador={idDependenciaEmpleador}
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={6}>
                      <Box display="flex" justifyContent="center" alignItems="center">
                        <InformacionImportarArchivoContainer />
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box display="flex" justifyContent="center" alignItems="center">

                        <>
                          {!isDownloadingNominas ? (
                            <FeatureLabel
                              labelText="DESCARGAR ÚLTIMO ESTADO DE NÓMINAS"
                              icon={<FileDownloadIcon />}
                              onClick={handleDescargarNominas}
                              tooltipText="Descargar"
                            />
                          ) : (
                            <>
                              <RequeridoLabel text="Descargando nóminas..." />
                              <StyledNte.LoadingIcon />
                            </>
                          )}

                        </>
                      </Box>

                    </Grid>

                  </Grid>
                  <StyledNte.ButtonContainer>
                    <FormikActions
                      submit="Siguiente"
                    />
                  </StyledNte.ButtonContainer>
                </Box>
              </>
            )}
        </Form>
      )}
    </Formik>
  )
}

export default ConfeccionDelArchivoForm;